const siteInfoActionTypes =  {    
    RETRIEVED_SITESETTINGS_PORTAL_SETTINGS: "RETRIEVED_SITESETTINGS_PORTAL_SETTINGS",
    UPDATED_SITESETTINGS_PORTAL_SETTINGS: "UPDATED_SITESETTINGS_PORTAL_SETTINGS",
    SITESETTINGS_PORTAL_SETTINS_CLIENT_MODIFIED: "SITESETTINGS_PORTAL_SETTINS_CLIENT_MODIFIED",
    RETRIEVED_PORTALS: "RETRIEVED_PORTALS",
    CHANGED_PORTAL_ID: "CHANGED_PORTAL_ID"
};
export default siteInfoActionTypes;
